var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuiviClient(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.4 19.6",
    style: {
      enableBackground: "new 0 0 15.4 19.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8 9.3h8.5v1.5H2.8zM2.8 13.3h8.5v1.5H2.8zM14 6.7H7.5V.1H9v5.1h5z",
    transform: "translate(.623 .623)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2 19H1.9C.5 19-.7 17.8-.7 16.4V1.9c0-.7.3-1.3.8-1.8s1.1-.8 1.8-.8h6.6l6.2 6.2v10.9c.1 1.5-1.1 2.6-2.5 2.6zM1.9.9c-.2 0-.5.1-.7.3-.2.2-.3.5-.3.7v14.5c0 .6.5 1.1 1.1 1.1h10.3c.6 0 1.1-.5 1.1-1.1V6.2L7.9.9h-6z",
    transform: "translate(.623 .623)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuiviClient);
export default __webpack_public_path__ + "static/media/suivi-client.00f20d594f0f1480387a7945c646f0ba.svg";
export { ForwardRef as ReactComponent };